import { createSlice } from "@reduxjs/toolkit";

const initialSectionSubjectProgressState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  courses: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const sectionSubjectProgressSlice = createSlice({
  name: "sectionSubjectProgress",
  initialState: initialSectionSubjectProgressState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },    
    // getSubjectProgress
    subjectProgressFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.completedSubjectCount = entity && entity.completedCount;
      state.totalSubjectCount = entity && entity.totalCount;
    },
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courses = entities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanListState
    listStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
    },
    //cleanSectionSubjectProgressState
    sectionSubjectProgressStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.totalSubjectCount = 0;
      state.completedSubjectCount = 0;
    }
  }
});